import { render, staticRenderFns } from "./ViewSheet.vue?vue&type=template&id=237e3e0f&scoped=true"
import script from "./ViewSheet.vue?vue&type=script&lang=js"
export * from "./ViewSheet.vue?vue&type=script&lang=js"
import style0 from "./ViewSheet.vue?vue&type=style&index=0&id=237e3e0f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237e3e0f",
  null
  
)

export default component.exports